import AsyncStorage from '@react-native-async-storage/async-storage';
import { AuthTokens } from '@/lib/types/auth';

export interface StorageData {
  auth?: AuthTokens | null;
  sidebarCollapsed?: boolean;
  /** Key of the right-sidebar tab open on last use; null/absent = collapsed. */
  rightSidebarActiveTool?: string | null;
}

class PersistentStorage<T extends Record<string, any>> {
  async get<K extends keyof T>(key: K): Promise<T[K] | null> {
    const value = await AsyncStorage.getItem(key.toString());
    if (!value) return null;
    return JSON.parse(value);
  }

  async set<K extends keyof T>(key: K, value: T[K]): Promise<void> {
    await AsyncStorage.setItem(key.toString(), JSON.stringify(value));
  }
}

export const persistentStorage = new PersistentStorage<StorageData>();
